import React from 'react';
import { DataTable, toast, Button as DsButton, PageTitle, SectionTitle } from '../../../components/ds';
import { Checkbox, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import { browserHistory } from 'react-router';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import AppState from '../../../state';
import { Utils } from '../../../services';
import * as impostoAPI from '../../../api/impostos';

const percentualMaskOptions = {
    prefix: '',
    suffix: ' %',
    includeThousandsSeparator: false,
    allowDecimal: true,
    decimalSymbol: ',' ? ',' : '.',
    decimalLimit: 2,
};

const inputMask = (mask) => ({ inputRef, ...other }) => {
    return <MaskedInput {...other} mask={mask} guide={false} />;
};

const percentualMask = inputMask(createNumberMask(percentualMaskOptions));

const getTodayDateISO = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

const TAX_TYPES = [
    { value: 'ISS', label: 'ISS' },
    { value: 'PIS', label: 'PIS' },
    { value: 'COFINS', label: 'COFINS' },
    { value: 'CSLL', label: 'CSLL' },
    { value: 'IBS', label: 'IBS' },
    { value: 'CBS', label: 'CBS' },
    { value: 'IR', label: 'IR' },
];

class Imposto extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeProjects: [],
            configuracoes: [],
            selectedProjects: [],
            tipoImposto: 'ISS',
            novaAliquota: '',
            dtIniVigencia: getTodayDateISO(),
            isSaving: false,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        AppState.isLoading = true;

        Promise.all([
            impostoAPI.getActiveProjects(),
            impostoAPI.getConfiguracaoImpostos(),
        ])
            .then(([projectsResponse, configuracoesResponse]) => {
                const activeProjects = (projectsResponse.request || []).map((item) => ({
                    ...item,
                    id_projeto: Number(item.id_projeto),
                }));

                this.setState({
                    activeProjects,
                    configuracoes: configuracoesResponse.request || [],
                    selectedProjects: activeProjects.length === 1 ? [activeProjects[0].id_projeto] : [],
                });
            })
            .catch((error) => {
                if (error.toString() === '' || error.toString().split(' ').length < 2) {
                    toast.error('Erro desconhecido, tente novamente');
                    return;
                }

                const errStatus = error.toString().split(' ')[1];
                if (errStatus === '401') {
                    browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
                } else {
                    toast.error('Erro ao carregar os impostos dos projetos');
                }
            })
            .finally(() => {
                AppState.isLoading = false;
            });
    };

    getCurrentConfigByProjectAndType = (projectId, tipoImposto) => {
        const projectConfigs = this.state.configuracoes.filter((item) => {
            return String(item.tipo_imposto) === String(tipoImposto);
        });

        const specificConfig = projectConfigs
            .filter((item) => String(item.id_projeto) === String(projectId))
            .sort((first, second) => {
                return String(second.dt_ini_vigencia || '').localeCompare(String(first.dt_ini_vigencia || ''));
            })[0];

        if (specificConfig) {
            return specificConfig;
        }

        const globalConfig = projectConfigs
            .filter((item) => item.id_projeto === null || item.id_projeto === undefined)
            .sort((first, second) => {
                return String(second.dt_ini_vigencia || '').localeCompare(String(first.dt_ini_vigencia || ''));
            })[0];

        return globalConfig || null;
    };

    getProjectTaxes = (projectId) => {
        return TAX_TYPES.reduce((accumulator, taxType) => {
            const config = this.getCurrentConfigByProjectAndType(projectId, taxType.value);
            accumulator[taxType.value] = config ? config.aliquota : null;
            return accumulator;
        }, {});
    };

    toggleProjectSelection = (projectId) => {
        this.setState((state) => {
            const idAsString = String(projectId);
            const selectedProjects = state.selectedProjects.map(String);
            const alreadySelected = selectedProjects.includes(idAsString);

            return {
                selectedProjects: alreadySelected
                    ? selectedProjects.filter((item) => item !== idAsString)
                    : [...selectedProjects, idAsString],
            };
        });
    };

    toggleSelectAll = () => {
        this.setState((state) => {
            const allIds = state.activeProjects
            .filter((project) => Number(project.id_projeto) !== 0)
            .map((project) => String(project.id_projeto));

            const selectedIds = state.selectedProjects.map(String);
            const allSelected = allIds.length > 0 && allIds.every((id) => selectedIds.includes(id));

            return {
                selectedProjects: allSelected ? [] : allIds,
            };
        });
    };

    handleChange = (name) => (event) => {
        this.setState({
            [name]: event.target.value,
        });
    };

    salvarImpostos = () => {
        if (!this.state.selectedProjects.length) {
            toast.error('Selecione ao menos um projeto');
            return;
        }

        if (!this.state.tipoImposto || this.state.novaAliquota === '') {
            toast.error('Informe o tipo do imposto e a nova porcentagem');
            return;
        }

        AppState.isLoading = true;
        this.setState({ isSaving: true });

       const projetosValidos = this.state.activeProjects.filter((projectId) => Number(projectId.id_projeto) !== 0);
       const selecionadosStrings = this.state.selectedProjects.map(String);
    
        const todosSelecionados = projetosValidos.length > 0 && projetosValidos.every((p) => selecionadosStrings.includes(String(p.id_projeto)));

        const idsParaEnviar = this.state.selectedProjects
            .map(Number)
            .filter((id) => id !== 0);

        const payload = {
            tipo_imposto: this.state.tipoImposto,
            nova_aliquota: Utils.percent2float(this.state.novaAliquota),
            dt_ini_vigencia: this.state.dtIniVigencia,
            id_projetos: todosSelecionados ? null : idsParaEnviar,
        };

        const formData = new FormData();
        formData.append('json', JSON.stringify(payload));

        impostoAPI
            .updateConfiguracaoImpostos(formData)
            .then(() => {
                toast.error('Impostos atualizados com sucesso');
                this.setState({ novaAliquota: '' });
                this.loadData();
            })
            .catch((error) => {
                if (error.toString() === '' || error.toString().split(' ').length < 2) {
                    toast.error('Erro desconhecido, tente novamente');
                    return;
                }

                const errStatus = error.toString().split(' ')[1];
                if (errStatus === '401') {
                    browserHistory.push(`${process.env.PUBLIC_URL}/logout`);
                    return;
                }

                if (errStatus === '400' && error.response && error.response.status) {
                    toast.error(error.response.status.value);
                    return;
                }

                toast.error('Erro ao atualizar os impostos');
            })
            .finally(() => {
                AppState.isLoading = false;
                this.setState({ isSaving: false });
            });
    };

    render() {
        const selectedProjects = this.state.selectedProjects.map(String);
        const allProjectIds = this.state.activeProjects
            .filter((project) => Number(project.id_projeto) !== 0)
            .map((project) => String(project.id_projeto));

        const allSelected =
            allProjectIds.length > 0 && allProjectIds.every((id) => selectedProjects.includes(id));

        const tableData = this.state.activeProjects
            .filter((project) => Number(project.id_projeto) !== 0)
            .map((project) => {
                return {
                    ...project,
                    currentTaxes: this.getProjectTaxes(project.id_projeto),
                };
            });

        return (
            <div id="imposto" style={{ marginTop: '5em' }}>
                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <PageTitle gutterBottom>
                            Impostos dos Projetos
                        </PageTitle>
                        <Typography variant="body1" style={{ marginBottom: '16px' }}>
                            Selecione um ou mais projetos ativos, escolha o tipo de imposto e envie a nova porcentagem.
                        </Typography>
                    </Grid>

                    {/* Coluna da Esquerda: Formulário + Tabela de Referência */}
                    <Grid item xs={12} md={4}>
                        <Paper style={{ padding: '16px', marginBottom: '16px' }}>
                            <FormControl fullWidth margin="dense">
                                <InputLabel id="tipo-imposto-label">Tipo do imposto</InputLabel>
                                <Select
                                    labelId="tipo-imposto-label"
                                    value={this.state.tipoImposto}
                                    onChange={this.handleChange('tipoImposto')}
                                >
                                    {TAX_TYPES.map((taxType) => (
                                        <MenuItem key={taxType.value} value={taxType.value}>
                                            {taxType.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <TextField
                                margin="dense"
                                label="Nova porcentagem"
                                value={this.state.novaAliquota}
                                onChange={this.handleChange('novaAliquota')}
                                fullWidth
                                InputProps={{
                                    inputComponent: percentualMask,
                                }}
                            />

                            <TextField
                                margin="dense"
                                label="Início da vigência"
                                type="date"
                                value={this.state.dtIniVigencia}
                                onChange={this.handleChange('dtIniVigencia')}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                            />

                            <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                                <DsButton
                                    variant="contained"
                                    color="primary"
                                    onClick={this.salvarImpostos}
                                    disabled={this.state.isSaving}
                                    fullWidth
                                >
                                    Salvar
                                </DsButton>
                            </div>

                            <Typography variant="caption" display="block" style={{ marginTop: '12px' }}>
                                Projetos selecionados: {this.state.selectedProjects.length}
                            </Typography>
                        </Paper>

                        {/* Tabela de Referência movida para baixo do formulário */}
                        <Paper style={{ padding: '16px' }}>
                            <SectionTitle gutterBottom>
                                Tabela de Referência (% sobre a receita)
                            </SectionTitle>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' }}>
                                    <TableHead>
                                        <TableRow>
                                            {['ANO', 'IBS', 'ISS', 'IBS + ISS', 'CBS', 'IVA', 'PIS', 'COFINS', 'IR', 'CSLL'].map((header) => (
                                                <TableCell key={header} style={{ color: '#222', fontWeight: 'bold', textAlign: 'center', padding: '8px' }}>
                                                    {header}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {[
                                            { ano: 2026, ibs: '0,10%', iss: '5,00%', tot1: '5,10%', cbs: '0,90%', iva: '6,00%', pis: '0,65%', cofins: '2,00%', ir: '8,80%', csll: '3,17%' },
                                            { ano: 2027, ibs: '0,10%', iss: '5,00%', tot1: '5,10%', cbs: '8,80%', iva: '13,90%', pis: '0,00%', cofins: '0,00%', ir: '8,80%', csll: '3,17%' },
                                            { ano: 2028, ibs: '0,10%', iss: '5,00%', tot1: '5,10%', cbs: '8,80%', iva: '13,90%', pis: '0,00%', cofins: '0,00%', ir: '8,80%', csll: '3,17%' },
                                            { ano: 2029, ibs: '2,30%', iss: '0,00%', tot1: '2,30%', cbs: '8,80%', iva: '11,10%', pis: '0,00%', cofins: '0,00%', ir: '8,80%', csll: '3,17%' },
                                            { ano: 2030, ibs: '7,10%', iss: '0,00%', tot1: '7,10%', cbs: '8,80%', iva: '15,90%', pis: '0,00%', cofins: '0,00%', ir: '8,80%', csll: '3,17%' },
                                            { ano: 2031, ibs: '10,60%', iss: '0,00%', tot1: '10,60%', cbs: '8,80%', iva: '19,40%', pis: '0,00%', cofins: '0,00%', ir: '8,80%', csll: '3,17%' },
                                            { ano: 2032, ibs: '14,20%', iss: '0,00%', tot1: '14,20%', cbs: '8,80%', iva: '23,00%', pis: '0,00%', cofins: '0,00%', ir: '8,80%', csll: '3,17%' },
                                            { ano: 2033, ibs: '17,70%', iss: '0,00%', tot1: '17,70%', cbs: '8,80%', iva: '26,50%', pis: '0,00%', cofins: '0,00%', ir: '8,80%', csll: '3,17%' },
                                        ].map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.ano}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.ibs}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.iss}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.tot1}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.cbs}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.iva}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.pis}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.cofins}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.ir}</TableCell>
                                                <TableCell align="center" style={{ padding: '8px' }}>{row.csll}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </table>
                            </div>
                        </Paper>
                    </Grid>

                    {/* Coluna da Direita: Apenas a ReactTable */}
                    <Grid item xs={12} md={8}>
                        <Paper style={{ padding: '16px' }}>
                            <DataTable
                                filterable
                                data={tableData}
                                defaultPageSize={10}
                                noDataText="Nenhum projeto ativo encontrado"
                                columns={[
                                    {
                                        Header: (
                                            <Checkbox checked={allSelected} onChange={this.toggleSelectAll} />
                                        ),
                                        id: 'select',
                                        sortable: false,
                                        filterable: false,
                                        maxWidth: 60,
                                        Cell: (row) => (
                                            <Checkbox
                                                checked={selectedProjects.includes(String(row.original.id_projeto))}
                                                onChange={() => this.toggleProjectSelection(row.original.id_projeto)}
                                            />
                                        ),
                                    },
                                    {
                                        Header: 'Projeto',
                                        accessor: 'desc_curta',
                                        Cell: (row) => (
                                            <div>
                                                <strong>{row.original.id_projeto}</strong> - {row.value}
                                            </div>
                                        ),
                                    },
                                    { Header: 'ISS', accessor: 'currentTaxes.ISS', Cell: (row) => <span>{row.value !== null && row.value !== undefined ? `${Utils.float2moeda(row.value)} %` : '-'}</span> },
                                    { Header: 'PIS', accessor: 'currentTaxes.PIS', Cell: (row) => <span>{row.value !== null && row.value !== undefined ? `${Utils.float2moeda(row.value)} %` : '-'}</span> },
                                    { Header: 'COFINS', accessor: 'currentTaxes.COFINS', Cell: (row) => <span>{row.value !== null && row.value !== undefined ? `${Utils.float2moeda(row.value)} %` : '-'}</span> },
                                    { Header: 'CSLL', accessor: 'currentTaxes.CSLL', Cell: (row) => <span>{row.value !== null && row.value !== undefined ? `${Utils.float2moeda(row.value)} %` : '-'}</span> },
                                    { Header: 'IBS', accessor: 'currentTaxes.IBS', Cell: (row) => <span>{row.value !== null && row.value !== undefined ? `${Utils.float2moeda(row.value)} %` : '-'}</span> },
                                    { Header: 'CBS', accessor: 'currentTaxes.CBS', Cell: (row) => <span>{row.value !== null && row.value !== undefined ? `${Utils.float2moeda(row.value)} %` : '-'}</span> },
                                    { Header: 'IR', accessor: 'currentTaxes.IR', Cell: (row) => <span>{row.value !== null && row.value !== undefined ? `${Utils.float2moeda(row.value)} %` : '-'}</span> },
                                    {
                                        Header: 'IVA (IBS+ISS+CBS)',
                                        id: 'IVA',
                                        accessor: (row) => {
                                            const { IBS, ISS, CBS } = row.currentTaxes;
                                            return (Number(IBS) || 0) + (Number(ISS) || 0) + (Number(CBS) || 0);
                                        },
                                        Cell: (row) => <span>{`${Utils.float2moeda(row.value)} %`}</span>,
                                    },
                                ]}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default Imposto;